import React from 'react'
import styled from 'styled-components'
import brandLogo from '../../assets/logo.svg'

const BrandLogoImg = styled.img<{ size: 'medium' | 'large' }>`
  margin-top: 40px;
  margin-bottom: 40px;

  ${(props) => {
    if (props.size === 'medium') {
      return `height: 50px;
    width: 50px;`
    } else if (props.size === 'large') {
      return `height: 100px;
    width: 100px;`
    }
    return ''
  }}
`
type CyBrandLogoProps = {
  size?: 'medium' | 'large'
}

function CyBrandLogo({ size = 'medium' }: CyBrandLogoProps) {
  return <BrandLogoImg size={size} src={brandLogo} />
}

export default CyBrandLogo
